import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { throwIfEmpty } from "rxjs/operators";
import { UserService } from "../../../../shared";
import { SysAdminService } from "../../services/sysadmin.service";
import { UserGroupAddUserGroupComponent } from "./add-user-group/add-user-group.component";
import { UserGroupEditUserGroupComponent } from "./edit-user-group/edit-user-group.component";

@Component({
	selector: "caass-user-group-table",
	templateUrl: "./user-group-table.component.html",
	styleUrls: ["./user-group-table.component.css"],
})
export class UserGroupTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService, private userService: UserService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadUserGroupList();
	}

	ngOnChanges() {
		this.errorMessage = "";

		this.loadUserGroupList();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() AllowDistrictGroups: boolean = false;
	@Input() CanEdit: any;
	@Input() SchoolID: any;
	@Output() GroupSelected: EventEmitter<any> = new EventEmitter();

	SelectedUserGroup: any = null;
	lstUserGroups: any = [];
	lstUserLevelDesc: any = [];
	lstActive: any = [];

	cols = [
		{ field: "UserGroupCD", header: "Code" },
		{ field: "UserGroupDesc", header: "Description" },
		{ field: "UserLevelDesc", header: "User Level" },
		{ field: "Active", header: "Active" },
	];

	pagerows: any = 5;
	pagefirst: any = 0;

	user: any;
	errorMessage: any = "";

	ToggleText: any = "Deactivate";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadUserGroupList() {
		this.loading = true;

		var result = this.sysAdminService.UserGroupGetListBySchoolID(this.SchoolID, this.userService.getCurrentUser().userID);
		result.subscribe(
			(response) => {
				this.lstUserGroups = response;

				for (var i = 0; i < this.lstUserGroups.length; i++) {
					var next = this.lstUserGroups[i];
					next.Active = this.ActiveText(next.Active);
				}

				this.lstUserLevelDesc = Array.from(new Set(this.lstUserGroups.map((item: any) => item.UserLevelDesc))).sort();
				this.lstActive = Array.from(new Set(this.lstUserGroups.map((item: any) => item.Active))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(UserGroupAddUserGroupComponent, {
			header: "Add User Group",
			width: "fit-content",
			data: {
				AllowDistrictGroups: this.AllowDistrictGroups,
				SchoolID: this.SchoolID,
				CurrentUserLevel: this.user.UserLevelID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadUserGroupList();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to Edit";
			return;
		}

		var ref = this.dialogService.open(UserGroupEditUserGroupComponent, {
			header: "Edit User Group",
			width: "fit-content",
			data: {
				AllowDistrictGroups: this.AllowDistrictGroups,
				SchoolID: this.SchoolID,
				UserGroup: this.SelectedUserGroup,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadUserGroupList();
			}
		});
	}

	onRowDblClick(usergroup) {
		this.SelectedUserGroup = usergroup;
		if (this.CanEdit) {
			this.onEdit();
		}
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to Toggle";
			return;
		}

		var active = this.SelectedUserGroup.Active == "Active" ? 0 : 1;

		var result = this.sysAdminService.UserGroupToggle(this.SelectedUserGroup.UserGroupID, active);
		result.subscribe(
			(response) => {
				this.loadUserGroupList();

				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedUserGroup = val.data;

		this.ToggleText = "Deactivate";
		if (this.SelectedUserGroup.Active == "Inactive") {
			this.ToggleText = "Activate";
		}

		this.GroupSelected.emit(this.SelectedUserGroup);
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedUserGroup = null;
		this.ToggleText = "Deactivate";

		this.GroupSelected.emit(this.SelectedUserGroup);
	}
	/////////////////////////////////////////

	ActiveText(val) {
		return val == 1 ? "Active" : "Inactive";
	}
}
